import React, {useState, useEffect} from 'react';
import {useForm, FormProvider} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import SelectInfinite from '../../../components/FormFields/SelectInfinite';
import InputText from '../../../components/FormFields/InputText';
import TextArea from '../../../components/FormFields/Textarea';
import * as yup from 'yup';
import {getLanguage, t} from 'react-switch-lang';
import {Col, Row} from 'react-bootstrap';
import PageHeader from '../components/PageHeader';
import {useHistory} from 'react-router-dom';
import {
  getPotentionalRisks,
  getAllSubProcesses,
  addLitigation,
  getAllSubCategories,
  getAllSubCauses,
  GetPotentionalRisk,
} from '../../../services/litigationService';
import SelectList from '../../../components/select/SelectList';
import './AddLitigation.scss';
import {useUserContext} from '../../../contexts/UserContext';
import Toast from '../../../components/toast/Toast';
import InputDate from '../../../components/FormFields/inputDate/InputDate';
import Trash from '../img/trash.svg';
import {useDepartmentContext} from '../../../contexts/DepartmentContext';
import {validDouble} from '../../../utils/const';
import allowedFileTypes from '../../../utils/allowedFileTypes';
import PreventTransitionPrompt from '../../../components/preventTransitionprompt/PreventTransition';
import {format} from 'date-fns';

const AddLitigation = () => {
  const lang = getLanguage();
  const user = useUserContext();
  const userDepartment = useDepartmentContext();

  const [disableSubprocess, setDisableSubPorcess] = useState(true);
  const [disableSubCauses, setDisableSubCauses] = useState(true);
  const [subProcesses, setSubProcesses] = useState([]);
  const [subCauses, setSubCauses] = useState([]);
  const [potentionalRisks, setPotentionalRisks] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [disableSubCategory, setDisableSubCategory] = useState(true);
  const [riskEstimation, setRiskEstimation] = useState(null);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [isAdding, setIsAdding] = useState(true);

  let history = useHistory();

  const bankLegitimation = [
    {value: 'RESPONDENT', label: lang === 'eng' ? 'Respondent' : 'Tuženi'},
    {value: 'PLAINTIFF', label: lang === 'eng' ? 'Plaintiff' : 'Tužilac'},
  ];

  const [schema, setSchema] = useState(
    yup.object().shape({
      title: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(150, t('message.max', {max: 150})),
      description: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(2048, t('message.max', {max: 2048})),
      riskCauseId: yup.object().nullable().required(t('message.fieldRequired')),
      departmentStakeholderId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      courtCategoryId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      subCategory: yup.object().nullable().required(t('message.fieldRequired')),
      // userResponsibleId: yup.object().nullable().required(t('message.fieldRequired')),
      estimatedGrossLost: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .matches(validDouble, t('message.onlyDecimalNumbers'))
        .max(20, t('message.max', {max: 20})),
      methodologyId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      comment: yup
        .string()
        .trim()
        .max(2048, t('message.max', {max: 2048})),
      typeCourtDispute: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(255, t('message.max', {max: 255})),
      bankLegitimation: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      proxyInfo: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(255, t('message.max', {max: 255})),
      litigationDate: yup
        .string()
        .nullable()
        .required(t('message.fieldRequired')),
      disputeSubject: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(255, t('message.max', {max: 255})),
      jurisdiction: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(255, t('message.max', {max: 255})),
      litigationValue: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .matches(validDouble, t('message.onlyDecimalNumbers'))
        .max(20, t('message.max', {max: 20})),
      provisionAmount: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .matches(validDouble, t('message.onlyDecimalNumbers'))
        .max(20, t('message.max', {max: 20})),
      reimbursementProvision: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .matches(validDouble, t('message.onlyDecimalNumbers'))
        .max(20, t('message.max', {max: 20})),
      litigationLoss: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .matches(validDouble, t('message.onlyDecimalNumbers'))
        .max(20, t('message.max', {max: 20})),
      subjectStatus: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(255, t('message.max', {max: 255})),
      process: yup.string().nullable().required(t('message.fieldRequired')),
      subprocessId: yup
        .string()
        .nullable()
        .required(t('message.fieldRequired')),
      riskSubCause: yup
        .string()
        .nullable()
        .required(t('message.fieldRequired')),
    })
  );

  const methods = useForm({
    resolver: yupResolver(schema),
  });

  const {handleSubmit, watch, setValue} = methods;
  const watchProcess = watch('process');
  const watchCategory = watch('courtCategoryId');
  const watchRiskCause = watch('riskCauseId');
  const watchRiskSubcause = watch('riskSubCause');
  const watchSubprocess = watch('subprocessId');
  const watchPotentialRisk = watch('riskType');

  const fetchSubprocesses = async () => {
    try {
      const {data} = await getAllSubProcesses(watchProcess['value']);
      return data;
    } catch (e) {}
  };

  const fetchSubCategories = async () => {
    try {
      const {data} = await getAllSubCategories(watchCategory['value']);
      return data;
    } catch (e) {}
  };

  const fetchSubcauses = async () => {
    try {
      const {data} = await getAllSubCauses(watchRiskCause['value']);
      // setSubProcesses(data);
      return data;
    } catch (e) {}
  };

  const fetchPotentionalRisks = async () => {
    try {
      const {data} = await getPotentionalRisks();
      return data;
    } catch (e) {}
  };

  useEffect(() => {
    fetchPotentionalRisks().then((r) => {
      let options = [];
      r.forEach((item) => {
        options.push({
          value: item.id,
          label: item.title,
        });
      });
      setPotentionalRisks(options);
    });
  }, []);

  useEffect(() => {
    let departmentsArray = [];
    userDepartment.forEach((item) => {
      departmentsArray.push({
        value: item.id,
        label: lang === 'eng' ? item.nameEn : item.name,
      });
      setDepartmentOptions(departmentsArray);
    });
  }, []);

  useEffect(() => {
    if (watchRiskCause?.value) {
      setDisableSubCauses(false);
      fetchSubcauses().then((r) => {
        let subCauses = [];
        r.forEach((item) => {
          subCauses.push(
            lang === 'eng'
              ? {value: item.id, label: item.nameEn}
              : {
                  value: item.id,
                  label: item.name,
                }
          );
        });
        setSubCauses(subCauses);
      });
    }
    if (watchRiskCause === null) {
      setValue('riskSubCause', '', {
        shouldValidate: false,
        shouldDirty: false,
      });
    }
  }, [watchRiskCause]);

  useEffect(() => {
    if (watchPotentialRisk?.value) {
      const fetchPotentialRiskData = async () => {
        try {
          const {data} = await GetPotentionalRisk(watchPotentialRisk?.value);
          setRiskEstimation(data[0].riskEstimationId);
        } catch (e) {
          // console.log(e);
        }
      };
      fetchPotentialRiskData();
    }
  }, [watchPotentialRisk]);
  const handleCancel = (e) => {
    e.preventDefault();
    // TO-DO redirect to litigations
    window.location = '/dashboard';
  };

  const submitForm = async (data) => {
    const files = document.getElementById('upload').files;
    const date =
      format(new Date(data.litigationDate), 'yyyy-MM-dd') +
      'T' +
      format(new Date(data.litigationDate), 'hh:mm:ss');
    const payload = {
      courtSubcategoryRiskId: data.subCategory.value,
      typeCourtDispute: data.typeCourtDispute,
      bankLegitimation: data.bankLegitimation.value,
      commissioner: data.proxyInfo,
      // startingDateDispute: new Date(data.litigationDate),
      startingDateDispute: date,
      subjectDispute: data.disputeSubject,
      jurisdiction: data.jurisdiction,
      valueCourtDispute: data.litigationValue,
      provisionAmount: data.provisionAmount,
      feeReservation: data.reimbursementProvision,
      lossDispute: data.litigationLoss,
      subjectStatus: data.subjectStatus,
      risk: {
        active: true,
        riskCategoryId: 3,
        userInChargeId: user.id,
        potentialRiskId: data.riskType ? data.riskType.value : null,
        title: data.title,
        description: data.description,
        typeGainLossId: data.typeGainLossId ? data.typeGainLossId.value : null,
        methodologyId: data.methodologyId.value,
        riskCauseId: data.riskCauseId.value,
        riskSubCauseId: watchRiskSubcause['value'],
        departmentStakeholderId: data.departmentStakeholderId.value,
        courtCategoryId: data.courtCategoryId.value,
        userResponsibleId: userDepartment[0].userResponsibleId,
        userResponsibleLogin: userDepartment[0].userResponsibleLogin,
        processId: watchProcess['value'],
        subprocessId: watchSubprocess['value'],
        estimatedGrossLost: data.estimatedGrossLost,
        comment: data.comment ? data.comment : '',
        businessLineId: data.businessLineId ? data.businessLineId.value : null,
        userCreatedId: user.id,
        riskEstimationId: riskEstimation,
      },
    };

    try {
      const response = await addLitigation(payload, files);
      if (response.status === 201) {
        await Toast.fire({
          title: t('litigation.messages.addSuccess'),
          icon: 'success',
        });
        setIsAdding(false);
      }
      await history.push(`/court-risk/${response.data.id}`);
    } catch (err) {
      if (err.response.data.code === 'risk-exists') {
        Toast.fire({
          title:
            lang === 'eng'
              ? err.response.data.description
              : t('litigation.messages.addErrorExists'),
          icon: 'error',
        });
        document.getElementById('title').focus();
        document.getElementById('title').select();
      } else {
        Toast.fire({
          title: t('litigation.messages.addError'),
          icon: 'error',
        });
        setIsAdding(false);
      }
    }
  };

  useEffect(() => {
    if (watchProcess?.value) {
      setDisableSubPorcess(false);
      fetchSubprocesses().then((r) => {
        let subProcesses = [];
        r.forEach((item) => {
          subProcesses.push(
            lang === 'eng'
              ? {value: item.id, label: item.nameEn}
              : {
                  value: item.id,
                  label: item.name,
                }
          );
        });
        setSubProcesses(subProcesses);
      });
    }
    setValue('subprocessId', '');
    if (watchProcess === null) {
      setValue('subprocessId', '', {
        shouldValidate: false,
        shouldDirty: false,
      });
    }
  }, [watchProcess]);

  useEffect(() => {
    if (watchCategory?.value) {
      setDisableSubCategory(false);
      fetchSubCategories().then((r) => {
        let subCategories = [];
        r.forEach((item) => {
          subCategories.push(
            lang === 'eng'
              ? {value: item.id, label: item.nameEn}
              : {
                  value: item.id,
                  label: item.name,
                }
          );
        });
        setSubCategories(subCategories);
      });
    }
    setValue('subCategory', '');
    if (watchCategory === null) {
      setValue('subCategory', '', {
        shouldValidate: false,
        shouldDirty: false,
      });
    }
  }, [watchCategory]);

  const [files, setFiles] = useState([]);

  const uploadOnChange = () => {
    const input = document.getElementById('upload');
    let children = [];
    if (input.files.length > 10) {
      Toast.fire({
        title: t('message.tooManyFiles'),
        icon: 'error',
      });
    } else {
      for (let i = 0; i < input.files.length; ++i) {
        if (input.files.item(i).size > 10485760) {
          Toast.fire({
            title: t('message.fileTooBig'),
            icon: 'error',
          });
        } else {
          children.push({
            id: input.files.item(i).name,
            label: input.files.item(i).name,
          });
          setFiles(children);
        }
      }
    }
  };

  const clearLocalFile = (index) => {
    const dt = new DataTransfer();
    const input = document.getElementById('upload');
    const {files} = input;
    let children = [];
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (index !== i) {
        dt.items.add(file); // here you exclude the file. thus removing it.
        children.push({
          id: input.files.item(i).name,
          label: input.files.item(i).name,
        });
      }
    }
    input.files = dt.files;
    setFiles(children);
  };

  const onChangeReimbursementProvision = (e) => {
    let result = '';
    let valueNoText = e.target.value.replace(/[^0-9.]/, '');
    let valueDouble = valueNoText.match(/^(\d+(?:(.|,)\d{1,2})?).*/);
    if (valueDouble !== undefined && valueDouble !== null) {
      result = valueDouble[1];
    }
    setValue('reimbursementProvision', result);
  };

  const onChangeLitigationLoss = (e) => {
    let result = '';
    let valueNoText = e.target.value.replace(/[^0-9.]/, '');
    let valueDouble = valueNoText.match(/^(\d+(?:(.|,)\d{1,2})?).*/);
    if (valueDouble !== undefined && valueDouble !== null) {
      result = valueDouble[1];
    }
    setValue('litigationLoss', result);
  };

  const onChangeProvisionAmount = (e) => {
    let result = '';
    let valueNoText = e.target.value.replace(/[^0-9.]/, '');
    let valueDouble = valueNoText.match(/^(\d+(?:(.|,)\d{1,2})?).*/);
    if (valueDouble !== undefined && valueDouble !== null) {
      result = valueDouble[1];
    }
    setValue('provisionAmount', result);
  };

  const onChangeLitigationValue = (e) => {
    let result = '';
    let valueNoText = e.target.value.replace(/[^0-9.]/, '');
    let valueDouble = valueNoText.match(/^(\d+(?:(.|,)\d{1,2})?).*/);
    if (valueDouble !== undefined && valueDouble !== null) {
      result = valueDouble[1];
    }
    setValue('litigationValue', result);
  };

  const onChangeEstimatedGrossLost = (e) => {
    let result = '';
    let valueNoText = e.target.value.replace(/[^0-9.]/, '');
    let valueDouble = valueNoText.match(/^(\d+(?:(.|,)\d{1,2})?).*/);
    if (valueDouble !== undefined && valueDouble !== null) {
      result = valueDouble[1];
    }
    setValue('estimatedGrossLost', result);
  };

  return (
    <>
      <PreventTransitionPrompt when={isAdding} />
      <PageHeader />
      <div className="main-form mt-4">
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(submitForm)}>
            <Row className="field-group-title">
              <Col className="col-4 col-xl-2">{t('litigation.mainData')}</Col>
            </Row>
            <Row className="mb-2">
              <Col className="col-6 col-xl-3">
                <label className="label-litigation">
                  {t('litigation.potentionalRisk')}
                </label>
                <span className="optional register">
                  {t('common.optional')}
                </span>
                <SelectList
                  name="riskType"
                  placeholder={t('litigation.placeholder.potentionalRisk')}
                  options={potentionalRisks}
                  isClearable
                />
                <label className="label-litigation">
                  {t('litigation.title')}
                </label>
                <InputText
                  type="text"
                  name="title"
                  id="title"
                  className="form-control input-field"
                  placeholder={t('litigation.placeholder.title')}
                />
              </Col>
              <Col className="col-6 col-xl-3">
                <label className="label-litigation">
                  {t('litigation.description')}
                </label>
                <TextArea
                  name="description"
                  className={`form-control text-area `}
                  placeholder={t('litigation.placeholder.description')}
                />
              </Col>
            </Row>
            <Row className="mt-5 field-group-title">
              <Col className="col-6 col-xl-3">
                {t('litigation.additionalInformation')}
              </Col>
            </Row>
            <Row className="mt-2">
              <Col className="col-3 col-xl-3">
                <label className="label-litigation">
                  {t('litigation.category')}
                </label>
                <SelectInfinite
                  api="court-category-risks"
                  name="courtCategoryId"
                  placeholder={t('litigation.placeholder.category')}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="select"
                />
                <label className="label-litigation">
                  {t('litigation.subCategory')}
                </label>
                <SelectList
                  name="subCategory"
                  isDisabled={disableSubCategory}
                  placeholder={t('litigation.placeholder.subCategory')}
                  options={subCategories}
                  isClearable
                />
                <label className="label-litigation">
                  {t('litigation.riskCauses')}
                </label>
                <SelectInfinite
                  api="risk-causes"
                  name="riskCauseId"
                  placeholder={t('litigation.placeholder.riskCauses')}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="select"
                />
              </Col>

              <Col className="col-3 col-xl-3">
                <label className="label-litigation">
                  {t('litigation.riskSubCause')}
                </label>
                <SelectList
                  name="riskSubCause"
                  isDisabled={disableSubCauses}
                  className="select"
                  placeholder={t('litigation.placeholder.riskSubCause')}
                  options={subCauses}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  isClearable
                />
                <label className="label-litigation">
                  {t('litigation.businessLines')}
                </label>
                <span className="optional register">
                  {t('common.optional')}
                </span>
                <SelectInfinite
                  api="business-lines"
                  name="businessLineId"
                  placeholder={t('litigation.placeholder.businessLines')}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="select"
                />
                <label className="label-litigation">
                  {t('litigation.process')}
                </label>
                <SelectInfinite
                  api="processes"
                  name="process"
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  placeholder={t('litigation.placeholder.process')}
                  className="select"
                />
              </Col>
              <Col className="col-3 col-xl-3">
                <label className="label-litigation">
                  {t('litigation.subprocess')}
                </label>
                <SelectList
                  name="subprocessId"
                  options={subProcesses}
                  isDisabled={disableSubprocess}
                  placeholder={t('litigation.placeholder.subprocess')}
                  isClearable
                />
                <label className="label-litigation">
                  {t('litigation.estimatedGrossLoss')}
                </label>
                <InputText
                  type="number"
                  name="estimatedGrossLost"
                  className="form-control input-field"
                  placeholder={t('litigation.placeholder.estimatedGrossLoss')}
                  step=".01"
                  min="0"
                  onChange={onChangeEstimatedGrossLost}
                />
                <label className="label-litigation">
                  {t('litigation.metodologies')}
                </label>
                <SelectInfinite
                  api="methodologies"
                  name="methodologyId"
                  placeholder={t('litigation.placeholder.metodologies')}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="select"
                />
              </Col>
              <Col className="col-3 col-xl-3">
                <label className="label-litigation">
                  {t('litigation.responsibleUser')}
                </label>
                <SelectInfinite
                  api="users"
                  name="userResponsibleId"
                  labelKey="firstName"
                  placeholder={t('litigation.placeholder.responsibleUser')}
                  className="select"
                  isDisabled={true}
                  defaultValue={{
                    value:
                      userDepartment[0]?.userResponsibleId !== undefined
                        ? userDepartment[0].userResponsibleId
                        : '',
                    label:
                      userDepartment[0]?.userResponsibleId !== undefined
                        ? userDepartment[0].userResponsibleFirstName +
                          ' ' +
                          userDepartment[0].userResponsibleLastName
                        : '',
                  }}
                />
                <label className="label-litigation">
                  {t('litigation.department')}
                </label>
                <SelectList
                  name="departmentStakeholderId"
                  options={departmentOptions}
                  placeholder={t('litigation.placeholder.department')}
                />
                <label className="label-litigation">
                  {t('litigation.typeGainLoss')}
                </label>
                <span className="optional register">
                  {t('common.optional')}
                </span>
                <SelectInfinite
                  api="type-gain-losses"
                  name="typeGainLossId"
                  placeholder={t('litigation.placeholder.typeGainLoss')}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="select"
                />
              </Col>
            </Row>
            <Row>
              <Col className="col-6 col-xl-3">
                <label className="label-litigation" htmlFor={'attachFile'}>
                  {t('litigation.attachFiles')}
                </label>
                <span className="optional register">
                  {t('common.optional')}
                </span>
                <InputText
                  id="upload"
                  type="file"
                  name="file"
                  multiple
                  className="file-input"
                  onChange={uploadOnChange}
                  accept={allowedFileTypes}
                />
                <div key={files}>
                  <ul>
                    {files.map((file, index) => (
                      <li key={file.id}>
                        <div className="d-flex align-items-center">
                          <span className="mr-2">{file.label}</span>
                          <img
                            src={Trash}
                            alt="trash"
                            onClick={(e) => {
                              e.preventDefault();
                              clearLocalFile(index);
                            }}
                          />
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </Col>
              <Col className="col-6 col-xl-3">
                <label className="label-litigation">
                  {t('litigation.additionalComment')}
                </label>
                <span className="optional register">
                  {t('common.optional')}
                </span>
                <TextArea
                  name="comment"
                  className={`form-control text-area`}
                  // placeholder={t('litigation.placeholder.additionalComment')} disabled={disabled}
                />
              </Col>
            </Row>
            <Row className="mt-5 field-group-title">
              <Col className="col-4 col-xl-2">
                {t('litigation.litigationInfo')}
              </Col>
            </Row>
            <Row>
              <Col className="col-6 col-xl-3">
                <label className="label-litigation">
                  {t('litigation.typeCourtDispute')}
                </label>
                <InputText
                  type="text"
                  name="typeCourtDispute"
                  className="form-control input-field"
                  placeholder={t('litigation.placeholder.typeCourtDispute')}
                />
              </Col>
              <Col className="col-6 col-xl-3">
                <label className="label-litigation" htmlFor="bankLegitimation">
                  {t('litigation.bankLegitimation')}
                </label>
                <SelectList
                  name="bankLegitimation"
                  placeholder={t('litigation.placeholder.bankLegitimation')}
                  options={bankLegitimation}
                  isClearable
                />
              </Col>
              <Col className="col-6 col-xl-3">
                <label className="label-litigation">
                  {t('litigation.proxyInfo')}
                </label>
                <InputText
                  type="text"
                  name="proxyInfo"
                  className="form-control input-field"
                  placeholder={t('litigation.placeholder.proxyInfo')}
                />
              </Col>
              <Col className="col-6 col-xl-3 d-flex flex-column">
                <label className="label-litigation">
                  {t('litigation.litigationDate')}
                </label>
                <InputDate
                  name="litigationDate"
                  placeholder={t('litigation.placeholder.litigationDate')}
                  style={{height: '45px!important', width: '100%'}}
                  isClearable={true}
                  // maxDate={new Date()}
                />
              </Col>
            </Row>
            <Row>
              <Col className="col-6 col-xl-3">
                <label className="label-litigation">
                  {t('litigation.disputeSubject')}
                </label>
                <InputText
                  type="text"
                  name="disputeSubject"
                  className="form-control input-field"
                  placeholder={t('litigation.placeholder.disputeSubject')}
                />
              </Col>
              <Col className="col-6 col-xl-3">
                <label className="label-litigation">
                  {t('litigation.jurisdiction')}
                </label>
                <InputText
                  type="text"
                  name="jurisdiction"
                  className="form-control input-field line-height"
                  placeholder={t('litigation.placeholder.jurisdiction')}
                />
              </Col>
              <Col className="col-6 col-xl-3">
                <label className="label-litigation">
                  {t('litigation.litigationValue')}
                </label>
                <InputText
                  type="number"
                  name="litigationValue"
                  className="form-control input-field"
                  placeholder={t('litigation.placeholder.litigationValue')}
                  step=".01"
                  min="0"
                  onChange={onChangeLitigationValue}
                />
              </Col>
              <Col className="col-6 col-xl-3">
                <label className="label-litigation">
                  {t('litigation.provisionAmount')}
                </label>
                <InputText
                  type="number"
                  name="provisionAmount"
                  className="form-control input-field line-height"
                  placeholder={t('litigation.placeholder.provisionAmount')}
                  step=".01"
                  min="0"
                  onChange={onChangeProvisionAmount}
                />
              </Col>
            </Row>
            <Row>
              <Col className="col-6 col-xl-3">
                <label className="label-litigation">
                  {t('litigation.reimbursementProvision')}
                </label>
                <InputText
                  type="number"
                  name="reimbursementProvision"
                  className="form-control input-field line-height"
                  placeholder={t(
                    'litigation.placeholder.reimbursementProvision'
                  )}
                  step=".01"
                  min="0"
                  onChange={onChangeReimbursementProvision}
                />
              </Col>
              <Col className="col-6 col-xl-3">
                <label className="label-litigation">
                  {t('litigation.litigationLoss')}
                </label>
                <InputText
                  type="number"
                  name="litigationLoss"
                  className="form-control input-field line-height"
                  placeholder={t('litigation.placeholder.litigationLoss')}
                  step=".01"
                  min="0"
                  onChange={onChangeLitigationLoss}
                />
              </Col>
              <Col className="col-6 col-xl-3">
                <label className="label-litigation">
                  {t('litigation.subjectStatus')}
                </label>
                <InputText
                  type="text"
                  name="subjectStatus"
                  className="form-control input-field"
                  placeholder={t('litigation.placeholder.subjectStatus')}
                />
              </Col>
            </Row>
            <Row className="mt-5 form-footer">
              <button
                className="secondary-btn"
                type="reset"
                onClick={handleCancel}
              >
                {t('buttons.cancel')}
              </button>
              <button className="primary-btn">{t('buttons.save')}</button>
            </Row>
          </form>
        </FormProvider>
      </div>
    </>
  );
};
export default AddLitigation;
